import {
  collection as firebaseCollection,
  query,
  where,
  documentId,
  onSnapshot,
  getDocs,
  doc,
  orderBy,
  limit,
  getCountFromServer,
  updateDoc,
} from "firebase/firestore";
import React from "react";
import { useSelector } from "react-redux";
import { db } from "../../../firebase";
import Message from "./Message";
import { Paper, Typography, Divider, Box } from "@mui/material";

function formatDate(someDateTimeStamp, t) {
  let dt = new Date(someDateTimeStamp);
  let date = dt.getDate();
  let diffDays = new Date().getDate() - date;
  let diffMonths = new Date().getMonth() - dt.getMonth();
  let diffYears = new Date().getFullYear() - dt.getFullYear();
  if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
    return t("today");
  } else if (diffYears === 0 && diffDays === 1) {
    return t("yesterday");
  } else {
    return dt.toLocaleDateString("pt-PT");
  }
}

const Messages = ({
  chatUid,
  collection,
  entityDonation,
  setLastMessageDate,
  chatInputUid,
  t,
}) => {
  const {
    messageReducer: { chatDonationDetail, recevierEntityDetail },
    auth: { profile },
  } = useSelector((state) => state);
  const [chatId, setChatId] = React.useState();
  const [messages, setMessages] = React.useState([]);
  const dates = new Set();
  async function getEntityDonationChat(
    entityDonationChatUid,
    collectionId,
    donationId
  ) {
    const q = query(
      firebaseCollection(
        db,
        "entityDonationsChat",
        entityDonationChatUid,
        "donationInfo"
      ),
      where(documentId(), "==", donationId + collectionId)
    );
    const resp = await getDocs(q);
    if (!resp.empty) {
      setChatId(resp.docs[0].data().chatUid);
      // getCount(resp.docs[0].data().chatUid);
    }
    return resp;
  }

  async function fetchEntityChatData() {
    try {
      const q = query(
        firebaseCollection(
          db,
          "entityChats",
          profile?.entity.entityId,
          "entityInfo"
        ),
        where(documentId(), "==", recevierEntityDetail?.userId)
      );
      const res = await getDocs(q);
      if (!res.empty) {
        const entityDonationChatUid = res.docs[0].data().entityDonationChatUid;
        await getEntityDonationChat(
          entityDonationChatUid,
          collection?.collection?.id,
          chatDonationDetail?.donation.donationId
        );
      }
    } catch (err) {
     // console.log(err);
    }
  }

  React.useEffect(() => {
    if (chatUid === undefined) {
      fetchEntityChatData();
    } else if (chatInputUid) {
      setChatId(chatInputUid);
    } else {
      setChatId(chatUid);
    }
  }, [chatInputUid]);

  React.useEffect(() => {
    const getData = () => {
      const q = query(
        firebaseCollection(db, "chats", chatId, "messages"),
        orderBy("date", "asc")
      );
      const unsub = onSnapshot(q, (snap) => {
        const arr = [];
        snap.forEach((doc) => {
          arr.push(doc.data());
        });
        setMessages([...arr]);
        setLastMessageDate(
          arr.length > 0 ? arr[arr.length - 1]?.date : undefined
        );
      });
      return () => {
        unsub();
      };
    };
    chatId && getData();
  }, [chatId]);

  const renderDate = (chat, dateNum) => {
    const timestampDate = chat.date.toDate();

    // Add to Set so it does not render again
    dates.add(dateNum);
    return (
      <Box>
        <Divider>
          <Typography variant="body1" textAlign={"center"}>
            {formatDate(timestampDate, t)}
          </Typography>
        </Divider>
      </Box>
    );
  };

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        marginTop: "7%",
        marginBottom: "9%",
        py: 2,
        px: 1,
      }}
      elevation={0}
    >
      {messages.length > 0 &&
        messages.map((message) => {
          return (
            <React.Fragment key={message.id}>
              {dates.has(message.date.toDate().toLocaleDateString())
                ? null
                : renderDate(
                    message,
                    message.date.toDate().toLocaleDateString()
                  )}
              <Message
                chatId={chatId}
                message={message}
                entityDonation={entityDonation}
                t={t}
              />
            </React.Fragment>
          );
        })}
    </Paper>
  );
};

export default Messages;
